import {
  GridValueGetterParams,
  GridColumnHeaderParams,
} from "@mui/x-data-grid-pro";
import { UpdatedTranslations } from "entities/translations/types";
import TranslationTableField from "modules/translations/components/TranslationTableField";
import { TranslationsParams } from "modules/translations/types";
import { AutoTranslateButton } from "shared/components/AutoTranslateButton";
import { Language } from "shared/constants/languages";
import { LocaleCode } from "shared/types/languages";
import { StyledHeaderCell } from "./styled";

type ColumnsProps = {
  updatedTranslations: UpdatedTranslations | null;
  handleUpdatedTranslations: (value: TranslationsParams) => void;
  handleAutoTranslate: (value: LocaleCode) => void;
  langsToTranslate: string[];
  isLoading?: boolean;
  readOnly: boolean;
  allLanguages: Language[];
  targetLanguage?: LocaleCode;
};

export const getDynamicTranslationsColumns = ({
  updatedTranslations,
  handleUpdatedTranslations,
  handleAutoTranslate,
  langsToTranslate = [],
  isLoading = false,
  readOnly,
  allLanguages,
  targetLanguage,
}: ColumnsProps) => {
  const renderTranslationInput = (
    locale: LocaleCode,
    rowValue: string,
    rowId: string | number,
  ) => {
    const currentValue = updatedTranslations?.[rowId]?.[locale] || rowValue;
    return (
      <TranslationTableField
        handleUpdatedTranslations={handleUpdatedTranslations}
        locale={locale}
        rowValue={currentValue}
        rowId={rowId}
        isLoading={isLoading}
      />
    );
  };

  return [
    {
      field: "content",
      headerName: "Content",
      editable: false,
      sortable: false,
      width: 200,
    },
    {
      field: "contentItem",
      headerName: "Content Item",
      editable: false,
      sortable: false,
      width: 200,
    },
    ...allLanguages.map((lang) => ({
      field: `translations.${lang.id}`,
      headerName: lang.name,
      editable: false,
      sortable: false,
      width: 320,
      renderCell: (params: GridValueGetterParams) =>
        renderTranslationInput(lang.id, params.value, params.id),
      renderHeader: (params: GridColumnHeaderParams) => (
        <StyledHeaderCell>
          {lang.name}
          {!readOnly && (
            <AutoTranslateButton
              key={lang.id}
              langId={lang.id}
              isLoading={isLoading && targetLanguage === lang.id}
              handleAutoTranslate={handleAutoTranslate}
            />
          )}
        </StyledHeaderCell>
      ),
    })),
  ];
};
